import moment from "moment";

/**
 * A date the way lists show it: "Today, 9:59 PM", "Yesterday, 5:29 PM",
 * "Mon, Oct 5, 8:29 PM", or with the year when it is not the current one.
 */
export const formatWhen = (dateTime) => {
  const when = moment(dateTime);
  if (!when.isValid()) return "";
  const now = moment();
  if (when.isSame(now, "day")) return `Today, ${when.format("LT")}`;
  if (when.isSame(now.clone().subtract(1, "day"), "day")) return `Yesterday, ${when.format("LT")}`;
  return when.format(when.isSame(now, "year") ? "ddd, MMM D, LT" : "MMM D, YYYY, LT");
};

/**
 * A length in seconds as 0:42, 3:12 or 1:02:03; a dash when there is none.
 */
export const formatSeconds = (seconds) => {
  const total = Math.floor(Number(seconds));
  if (!(total > 0)) return "—";
  const hrs = Math.floor(total / 3600);
  const mins = Math.floor((total % 3600) / 60);
  const secs = String(total % 60).padStart(2, "0");
  return hrs > 0 ? `${hrs}:${String(mins).padStart(2, "0")}:${secs}` : `${mins}:${secs}`;
};
